import gql from 'graphql-tag';
import WaveTab from './fragmentWaveTab';

export default gql`
  mutation CreateWave($input: CreateWaveInput!) {
    createWave(input: $input) {
      wave {
        ...WaveTab
      }
    }
  }
  ${WaveTab}
`;



// WEBPACK FOOTER //
// ./src/queries/createWave.js